/* 壹品購物車頁（桌機 ≥1200 兩欄）：把 Ako 動態注入的「發票＋運送方式」區塊搬到左欄商品清單下方的白卡
   （#eepi-akoslot），右欄只留金額與結帳鈕，左右高度平衡。窄於 1200 或 Ako 未載入時維持原位。
   Ako 的事件綁在節點上，搬移 DOM 不影響其運作；cart.js 的 Section Rendering 只換 .js-contents，不會碰到它。 */
(function () {
  var slot = document.getElementById('eepi-akoslot');
  if (!slot) return;
  var mq = window.matchMedia('(min-width: 1200px)');
  var home = null;
  /* 只搬 #akocommerce_cvs_section 本體：Ako 的外層 wrapper 同時包著結帳鈕，不能一起搬 */
  var wrapOf = function () { return document.getElementById('akocommerce_cvs_section'); };
  var place = function () {
    var wrap = wrapOf();
    if (!wrap) return;
    if (mq.matches) {
      if (wrap.parentElement !== slot) {
        home = { p: wrap.parentElement, n: wrap.nextSibling };
        slot.appendChild(wrap);
        slot.hidden = false;
      }
    } else if (home && wrap.parentElement === slot) {
      home.p.insertBefore(wrap, home.n);
      slot.hidden = true;
    }
  };
  var ctas = document.querySelector('.cart__ctas');
  if (ctas) new MutationObserver(place).observe(ctas, { childList: true, subtree: true });
  mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place);
  place();
})();

/* 加購區「加入購物車」後的購物車頁即時更新：
   Dawn 原本的 cart-items.onCartUpdate 會把整個 <cart-items> 內容換掉（連上面搬進左欄的 Ako 卡一起清掉），而且不更新摘要卡。
   這裡改成和改數量同一套做法：只重抓兩個區段的 .js-contents（商品清單＋免運條、明細＋總金額）。 */
(function () {
  var itemsWrap = document.getElementById('main-cart-items');
  var footer = document.getElementById('main-cart-footer');
  if (!itemsWrap || !footer) return;
  customElements.whenDefined('cart-items').then(function () {
    var proto = customElements.get('cart-items').prototype;
    var orig = proto.onCartUpdate;
    proto.onCartUpdate = function () {
      if (this.tagName !== 'CART-ITEMS') return orig.call(this);
      var ids = [itemsWrap.dataset.id, footer.dataset.id];
      return fetch(window.routes.cart_url + '?sections=' + ids.join(','))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var swap = function (root, html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var from = doc.querySelector('.js-contents');
            var to = root.querySelector('.js-contents');
            if (from && to) to.innerHTML = from.innerHTML;
            return doc;
          };
          var doc = swap(itemsWrap, sections[ids[0]]);
          var live = document.querySelector('cart-items');
          var fresh = doc.querySelector('cart-items');
          if (live && fresh) live.className = fresh.className;
          var fdoc = swap(footer, sections[ids[1]]);
          var ffresh = fdoc.getElementById('main-cart-footer');
          if (ffresh) footer.classList.toggle('is-empty', ffresh.classList.contains('is-empty'));
        })
        .catch(function (e) { console.error(e); });
    };
  });
  /* 購物車頁不跳「已加入購物車」小視窗（清單本身就會更新）；仍讓它更新標頭購物車數字 */
  customElements.whenDefined('cart-notification').then(function () {
    var n = document.querySelector('cart-notification');
    if (n) n.open = function () {};
  });
})();
